<script setup>

const route = useRoute()
const speaker_id = route.params.id
const params = { id: speaker_id }

const { data, pending, error, clear, status } = await useAsyncData(`speaker-${speaker_id}`, () => $fetch(`/api/v2/speakers`, { params: { ...params } }))

if (error.value) {
    throw createError({
        statusCode: 404,
        statusMessage: 'Page Not Found',
        fatal: true,
    });
}

useSeoMeta({
    title: data.value.speakers[0].name,
    ogTitle: data.value.speakers[0].name,
    description: data.value.speakers[0].description,
    ogDescription: data.value.speakers[0].description,
    ogImage: '/social.jpg',
    twitterCard: 'summary_large_image',
});

const page = computed(() => {
    if (!data.value?.speakers?.length) return false
    return { id: data.value.speakers[0].id, data: data.value.speakers[0], model: 'speakers' }
})

</script>

<template>
    <ProjectPage :page="page" data-model="speaker" v-if="!pending && page">
        <SpeakersModal :speaker="page.data" hero />
    </ProjectPage>
</template>

<style lang='scss'>
[data-model="speaker"] {
    background: var(--teal);
}
</style>